export interface IPermission {
  addResolution?: boolean;
  vote?: boolean;
  finishedEvent?: boolean;
  changeAbsenceStatus?: boolean;
  changePreResolutionStatus?: boolean;
  changeMaterialStatus?: boolean;
}
